export var getIsAccordionInView = function getIsAccordionInView(activeAccordionItem) {
  return activeAccordionItem.getBoundingClientRect().bottom < global.innerHeight;
};